module.exports = __webpack_public_path__ + "img/share_logo.65211893.png";